import { render } from "./TaskDeleteModal.vue?vue&type=template&id=230cc2ff&scoped=true&ts=true"
import script from "./TaskDeleteModal.vue?vue&type=script&lang=ts"
export * from "./TaskDeleteModal.vue?vue&type=script&lang=ts"

import "./TaskDeleteModal.vue?vue&type=style&index=0&id=230cc2ff&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230cc2ff"]])

export default __exports__